import api, { PhotoData } from '@/service/api';

// Reconcile ambiguous POST failures: the server may have committed before the connection broke.
export default async function saveMetadata(id: string, sessionId: string, data: PhotoData, overwrite: boolean, reconcile = false) {
    const alreadySaved = async () => {
        const photo = (await api.loadSessionPhotos(sessionId)).find(photo => photo.id === id);
        return !!photo && photo.dataHash === data.checksum && photo.filename === data.filename &&
            photo.perceptualHash === data.perceptualHash &&
            photo.dimensions.width === data.dimensions.width && photo.dimensions.height === data.dimensions.height &&
            photo.smallThumbDimensions.width === data.smallThumbnailDimensions.width &&
            photo.smallThumbDimensions.height === data.smallThumbnailDimensions.height &&
            photo.largeThumbDimensions.width === data.largeThumbnailDimensions.width &&
            photo.largeThumbDimensions.height === data.largeThumbnailDimensions.height;
    };
    if (reconcile && await alreadySaved()) return;
    try {
        if (overwrite) await api.updatePhoto(id, sessionId, data);
        else await api.savePhoto(id, sessionId, data);
    } catch (error) {
        if ([400, 401, 403, 404, 422].includes(error?.response?.status)) throw error;
        // Preserve the original write error if reconciliation is also unavailable.
        if (await alreadySaved().catch(() => false)) return;
        throw error;
    }
}
